import AppHeader from '../AppHeader';

interface DocHeaderProps {
  org: string;
  collection: string;
}

export default function DocHeader({ org: _org, collection: _collection }: DocHeaderProps) {
  return <AppHeader showDashboardLink />;
}
